import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import ecomcategoriesModel from "../../models/ecomcategories.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import { Dropdown } from "react-bootstrap";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: ecomcategoriesData, mutate: reloadEcomcategoriesData, isLoading } = useSWR(
        queryParams || null,
        () => ecomcategoriesModel.list(queryParams),
        config.swrConfig
    );

    const columns = [

        {
            Header: 'Image',
            className: 'col',
            id: 'image',
            Cell: ({ row }) => (
                <>  <img src={row.original.thumbnail} height="40px" width="50px" /> </>
            ),
        },
        {
            Header: "Title",
            accessor: "title",
            className: "col"
        },
        {
            Header: "Parent Category",
            accessor: "parent.title",
            className: "col"
        },
        {
            Header: "Description",
            accessor: "description",
            className: "col"
        },
        {
            Header: "Status",
            accessor: "status",
            className: "col"
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                        {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
        },

        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div >

                        <Dropdown className="btn-group btn-group-sm">
                            <Link
                                className="btn btn-outline-primary"
                                href={`/ecomcategories/${row.original.id}`}
                            >
                                <i className="bi bi-eye"></i>
                            </Link>
                            <Dropdown.Toggle size="sm" variant="outline-primary">
                                <i className="bi bi-three-dots-vertical"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    className="btn btn-warning"
                                    href={`/ecomcategories/${row.original.id}/edit`}
                                >
                                    <i className="bi bi-pencil-square"></i> Edit
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item>
                                    <Link
                                        className="text-decoration-none text-dark"
                                        href={`/ecomcategories/${row.original.id}/excel`}
                                    >
                                        <i className="bi bi-file-earmark-spreadsheet"></i> Excel
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item as="button" type="button"
                                    className="text-danger"
                                    onClick={() => confirmDelete(row.original.id, row.original.title)}
                                >
                                    <i className="bi bi-trash"></i> Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </>
            ),
        },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowLoader(true);
                    await ecomcategoriesModel.destroy(id).then((res) => {
                        reloadEcomcategoriesData();
                        helper.sweetalert.toast(`${title} deleted Successfully`);
                    });
                    setShowLoader(false);
                }
            });
    };

    return (
        <>
            <Heading title="Ecom-categories" showLoader={isLoading || showLoader}>
                {console.log()}
                <Link className="btn btn-primary btn-sm" href="/ecomcategories/create">
                    <i className="bi bi-plus" />  Create
                </Link>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">ecomcategories list</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={ecomcategoriesData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={ecomcategoriesData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
